import React, { useEffect, useState } from 'react'
import { Table, Button, Modal, Form, Input, Space, Popconfirm, message } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import api from '../api'
import useStore from '../store'

export default function OwnersPage() {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [form] = Form.useForm()
  const { user } = useStore()
  const canEdit = user?.role !== 'readonly'

  const load = () => api.get('/owners').then(setData)
  useEffect(() => { load() }, [])

  const openModal = (record = null) => {
    setEditing(record)
    form.setFieldsValue(record ? { name: record.name, note: record.note } : { name: '', note: '' })
    setOpen(true)
  }

  const onSave = async () => {
    const values = await form.validateFields()
    try {
      if (editing) { await api.put(`/owners/${editing.id}`, values) }
      else { await api.post('/owners', values) }
      message.success('保存成功')
      setOpen(false)
      load()
    } catch (err) { message.error(err) }
  }

  const columns = [
    { title: '负责人姓名', dataIndex: 'name', width: 150 },
    { title: '备注介绍', dataIndex: 'note', ellipsis: true },
    { title: '创建时间', dataIndex: 'created_at', width: 120, render: v => new Date(v).toLocaleDateString() },
    canEdit && {
      title: '操作', width: 120, render: (_, r) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => openModal(r)} />
          <Popconfirm title="确认删除？" onConfirm={async () => { await api.delete(`/owners/${r.id}`); load() }}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ].filter(Boolean)

  return (
    <div>
      {canEdit && (
        <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()} style={{ marginBottom: 16 }}>
          新增负责人
        </Button>
      )}
      <Table dataSource={data} columns={columns} rowKey="id" />
      <Modal title={editing ? '编辑负责人' : '新增负责人'} open={open} onOk={onSave} onCancel={() => setOpen(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="姓名" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="note" label="备注介绍"><Input.TextArea rows={3} placeholder="职责、负责范围等" /></Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
